<template>
  <div>
    <b-form @submit="sendForm" @reset="onReset" v-if="show">

      <!-- <b-form-group
        id="group_el_name"
        class="text-left"
        :label="$t('patient_create.el_name_label')"
        label-for="input_el_name"
        :description="$t('patient_create.el_name_desc')"
        :invalid-feedback="form_invalid_feedback.el_name"
        :state="form_state.el_name"
      >
        <b-form-input
          id="input_el_name"
          type="text"
          v-model.trim="form.el_name"
          required
          :state="form_state.el_name"
          :placeholder="$t('patient_create.el_name_placeholder')"
        ></b-form-input>
      </b-form-group> -->



      <b-form-group
        id="group_firstname"
        class="text-left"
        :label="$t('patient_create.firstname_label')"
        label-for="input_firstname"
        :invalid-feedback="form_invalid_feedback.firstname"
        :state="form_state.firstname"
      >
        <b-form-input
          id="input_firstname"
          v-model.trim="form.firstname"
          type="text"
          required
          :state="form_state.firstname"
          :placeholder="$t('patient_create.firstname_placeholder')"
        ></b-form-input>
      </b-form-group>


      <b-form-group
        id="group_lastname"
        class="text-left"
        :label="$t('patient_create.lastname_label')"
        label-for="input_lastname"
        :invalid-feedback="form_invalid_feedback.lastname"
        :state="form_state.lastname"
      >
        <b-form-input
          id="input_lastname"
          v-model.trim="form.lastname"
          type="text"
          required
          :state="form_state.lastname"
          :placeholder="$t('patient_create.lastname_placeholder')"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="group_email"
        class="text-left"
        :label="$t('patient_create.email_label')"
        label-for="input_email"
        :invalid-feedback="form_invalid_feedback.email"
        :state="form_state.email"
      >
        <b-form-input
          id="input_email"
          v-model.trim="form.email"
          type="text"
          required
          :state="form_state.email"
          :placeholder="$t('patient_create.email_placeholder')"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="group_identification_type"
        class="text-left"
        :label="$t('patient_create.identification_type_label')"
        label-for="input_identification_type"
        :invalid-feedback="form_invalid_feedback.identification_type"
        :state="form_state.identification_type"
      >
        <b-form-select id="input_identification_type" v-model="form.identification_type" class="mb-3">
          <option 
            v-for="(option_txt, index) in ['', $t('patient_create.id_type_passport'), $t('patient_create.id_type_ine')]"
            :value="index"
            v-bind:key="index"
          >
            {{ option_txt }}
          </option>

        </b-form-select>

      </b-form-group>


      <b-form-group
        id="group_identification_expiration"
        class="text-left"
        :label="$t('patient_create.identification_expiration_label')"
        label-for="input_identification_expiration"
        :invalid-feedback="form_invalid_feedback.identification_expiration"
        :state="form_state.identification_expiration"
      >
        <b-form-input
          id="input_identification_expiration"
          v-model.trim="form.identification_expiration"
          type="text"
          required
          :state="form_state.identification_expiration"
          :placeholder="$t('patient_create.identification_expiration_placeholder')"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        class="text-left"
        :label="$t('patient_create.identification_file_label')"
        label-for="input_identification_file"
        :invalid-feedback="form_invalid_feedback.identification_file"
        :state="form_state.identification_file"
      >
        <b-form-file
          id="input_identification_file"
          v-model="form.identification_file"
          :state="Boolean(form.identification_file)"
          :placeholder="$t('patient_create.identification_file_placeholder')">
        </b-form-file>
      </b-form-group>

      <b-form-group
        id="group_address"
        class="text-left"
        :label="$t('patient_create.address_label')"
        label-for="input_address"
        :invalid-feedback="form_invalid_feedback.address"
        :state="form_state.address"
      >
        <b-form-input
          id="input_address"
          v-model.trim="form.address"
          type="text"
          required
          :state="form_state.address"
          :placeholder="$t('patient_create.address_placeholder')"
        ></b-form-input>
      </b-form-group>


      <b-form-group
        id="group_town"
        class="text-left"
        :label="$t('patient_create.town_label')"
        label-for="input_town"
        :invalid-feedback="form_invalid_feedback.town"
        :state="form_state.town"
      >
        <b-form-input
          id="input_town"
          v-model.trim="form.town"
          type="text"
          required
          :state="form_state.town"
          :placeholder="$t('patient_create.town_placeholder')"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="group_colony"
        class="text-left"
        :label="$t('patient_create.colony_label')"
        label-for="input_colony"
        :invalid-feedback="form_invalid_feedback.colony"
        :state="form_state.colony"
      >
        <b-form-input
          id="input_colony"
          v-model.trim="form.colony"
          type="text"
          required
          :state="form_state.colony"
          :placeholder="$t('patient_create.colony_placeholder')"
        ></b-form-input>
      </b-form-group>


      <b-form-group
        id="group_postal_code"
        class="text-left"
        :label="$t('patient_create.postal_code_label')"
        label-for="input_postal_code"
        :invalid-feedback="form_invalid_feedback.postal_code"
        :state="form_state.postal_code"
      >
        <b-form-input
          id="input_postal_code"
          v-model.trim="form.postal_code"
          type="text"
          required
          :state="form_state.postal_code"
          :placeholder="$t('patient_create.postal_code_placeholder')"
        ></b-form-input>
      </b-form-group>


      <b-form-group
        id="group_federal_entity"
        class="text-left"
        :label="$t('patient_create.federal_entity_label')"
        label-for="input_federal_entity"
        :invalid-feedback="form_invalid_feedback.federal_entity"
        :state="form_state.federal_entity"
      >
        <b-form-input
          id="input_federal_entity"
          v-model.trim="form.federal_entity"
          type="text"
          required
          :state="form_state.federal_entity"
          :placeholder="$t('patient_create.federal_entity_placeholder')"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="group_mobile"
        class="text-left"
        :label="$t('patient_create.mobile_label')"
        label-for="input_mobile"
        :invalid-feedback="form_invalid_feedback.mobile"
        :state="form_state.mobile"
      >
        <b-form-input
          id="input_mobile"
          v-model.trim="form.mobile"
          type="text"
          required
          :state="form_state.mobile"
          :placeholder="$t('patient_create.mobile_placeholder')"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="group_phone"
        class="text-left"
        :label="$t('patient_create.phone_label')"
        label-for="input_phone"
        :invalid-feedback="form_invalid_feedback.phone"
        :state="form_state.phone"
      >
        <b-form-input
          id="input_phone"
          v-model.trim="form.phone"
          type="text"
          required
          :state="form_state.phone"
          :placeholder="$t('patient_create.phone_placeholder')"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="group_phone_extension"
        class="text-left"
        :label="$t('patient_create.phone_extension_label')"
        label-for="input_phone_extension"
        :invalid-feedback="form_invalid_feedback.phone_extension"
        :state="form_state.phone_extension"
      >
        <b-form-input
          id="input_phone_extension"
          v-model.trim="form.phone_extension"
          type="text"
          required
          :state="form_state.phone_extension"
          :placeholder="$t('patient_create.phone_extension_placeholder')"
        ></b-form-input>
      </b-form-group>
      <b-button type="submit" variant="primary">Submit</b-button>

    </b-form>
  </div>
</template>


<script>
import { mapState } from "vuex";

export default {
  name: "patient-create-form",
  data() {
    return {
      form: {
        firstname: "",
        lastname: "",
        email: "",
        identification_type: "",
        identification_expiration: "",
        identification_file: "",
        address: "",
        town: "",
        colony: "",
        postal_code: "",
        federal_entity: "",
        mobile: "",
        phone: "",
        phone_extension: "",
      },
      form_invalid_feedback: {},
      form_state: {},
      show: true,
    };
  },
  computed: {
    ...mapState({
      country_fields: state => state.siteconf.country_fields,
    }),
  },
  fallbackI18n: {
    messages: {
      und: {
        patient_create: {
          firstname_label: "Firstname",
          firstname_desc: "Firstname",
          firstname_placeholder: "Firstname",
          lastname_label: "Lastname",
          lastname_desc: "Lastname",
          lastname_placeholder: "Lastname",
          email_label: "Email",
          email_desc: "Email",
          email_placeholder: "Email",
          mobile_label: "Mobile",
          mobile_desc: "Mobile",
          mobile_placeholder: "Mobile",
          phone_label: "Phone",
          phone_desc: "Phone",
          phone_placeholder: "Phone",
          phone_extension_label: "Phone extension",
          phone_extension_desc: "Phone extension",
          phone_extension_placeholder: "Phone extension",
          identification_type_label: "Identification type",
          identification_type_desc: "Identification type",
          identification_type_placeholder: "Identification type",
          identification_expiration_label: "Identification expiration",
          identification_expiration_desc: "Identification expiration",
          identification_expiration_placeholder: "Identification expiration",
          identification_file_label: "Identification file",
          identification_file_desc: "Identification file",
          identification_file_placeholder: "Identification file",
          address_label: "Tax address",
          address_desc: "Tax address",
          address_placeholder: "Tax address",
          town_label: "Tax town",
          town_desc: "Tax town",
          town_placeholder: "Tax town",
          colony_label: "Tax colony",
          colony_desc: "Tax colony",
          colony_placeholder: "Tax colony",
          postal_code_label: "Tax postal code",
          postal_code_desc: "Tax postal code",
          postal_code_placeholder: "Tax postal code",
          federal_entity_label: "Tax federal entity",
          federal_entity_desc: "Tax federal entity",
          federal_entity_placeholder: "Tax federal entity",
          id_type_passport: "Passport",
          id_type_ine: "INE",
          submit_button: "Submit",
          reset_button: "Reset",
        },
      },
    },
  },
  methods: {
    sendForm(evt) {
      evt.preventDefault();
      var data = this.form;
      this.$store
        .dispatch("naturalperson/NEW_PATIENTDATA", { data: data })
        .then(
          () => {
            this.$emit("patient-created");
          },
          err => {
            this.showResponseError(err.response);
            this.putFormFeedback(err.response);
          }
        );
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.email = "";
      this.form.name = "";
      this.form.checked = [];
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>


<style scoped>
.dialog-footer {
  display: flex;
  justify-content: space-between;
}

.form-submit .el-button {
  width: 100%;
}
</style>
